<template>
  <div class="how-to-get bg--color-02">
    <div class="container-wrapper bg--color-11">
      <div class="how-to-get__container container-new">
        <div class="how-to-get__image">
          <img
            loading="lazy"
            :src="require('@/assets/img/token/extra.svg')"
            alt="coin image"
          >
        </div>

        <div class="how-to-get__content flx flx--col">
          <span
            class="txt txt--26px txt--height-34px txt--44px--m txt--height-58px--m txt--color-04 txt--bold"
          >
            {{ $t('tokenNew.howToGetBlock.label') }} {{ $t('tokenNew.howToGetBlock.title') }}
          </span>

          <span
            class="txt txt--16px txt--height-29px txt--22px--m txt--height-30px--m txt--color-0 pt-18"
          >
            {{ $t('tokenNew.howToGetBlock.subtitle') }}
          </span>
        </div>

        <div class="how-to-get__btn flx flx--col">
          <!-- <button-with-arrow
            full-width
            size="l"
            :to="localePath('/exchange')"
            class="how-to-get__btn-item"
          >
            {{ $t('tokenNew.howToGetBlock.getExtraBtn') }}
          </button-with-arrow> -->
          <exc-button
            class="how-to-get__btn-item"
            soon
            full-width
            color="dark"
            size="l"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  components: {
    ExcButton,
    // ButtonWithArrow: () => import('@/components/welcome/elements/ButtonWithArrow.vue'),
  },
}
</script>

<style lang="scss" scoped>
.how-to-get {
  &__image {
    grid-area: image;
    text-align: center;

    @include bp(m) {
      text-align: unset;
    }

    img {
      margin: auto;
      // margin-top: auto;
      // margin-bottom: auto;
    }
  }

  &__content {
    grid-area: content;
  }

  &__btn {
    grid-area: button;
    justify-content: center;

    @include bp(m) {
      max-width: fit-content;
    }
  }

  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(22px);
    grid-template-areas:
      'image'
      'content'
      'button';

    @include bp(m) {
      grid-template-columns: toRem(200px) 1fr;
      align-items: center;
      grid-template-areas:
        'image content'
        'image button';
      gap: toRem(22px) toRem(32px);
    }

    @include bp(1120px) {
      grid-template-columns: toRem(200px) 1fr toRem(260px);
      grid-template-areas: 'image content button';
      gap: 0 toRem(32px);
    }
  }
}
</style>
